import { render, staticRenderFns } from "./ImportTrucks.vue?vue&type=template&id=ac0732f4&scoped=true"
import script from "./ImportTrucks.vue?vue&type=script&lang=js"
export * from "./ImportTrucks.vue?vue&type=script&lang=js"
import style0 from "./ImportTrucks.vue?vue&type=style&index=0&id=ac0732f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0732f4",
  null
  
)

export default component.exports